
import { useState, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import DropboxUploadModal from "./components/feature/DropboxUploadModal";


function App() {
  const [isDropboxModalOpen, setIsDropboxModalOpen] = useState(false);

  useEffect(() => {
    const handleOpenModal = () => setIsDropboxModalOpen(true);
    window.addEventListener('openDropboxUploadModal', handleOpenModal);
    return () => window.removeEventListener('openDropboxUploadModal', handleOpenModal);
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
        <DropboxUploadModal 
          isOpen={isDropboxModalOpen} 
          onClose={() => setIsDropboxModalOpen(false)}
        />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
